export const TEST_ID = 'orgFieldPicker';

export const ORGANIZATION_ROW_TEST_ID = 'orgFieldPickerOrganizationRow';

export const FIELD_ROW_TEST_ID = 'orgFieldPickerFieldRow';
